import { filterTableRowsBySelectedKiTags } from '../ki/calcExcludedKiTagKiCount';
import { KiTagListOptions } from '../schemas';
import { DataKiSyokenResponse } from './types';

/**
 * 機種別商圏のタグ絞り込み。
 */
export const dataKiSyokenFilteredByKiTagList = (
  dataKiSyoken: DataKiSyokenResponse,
  kiTagList: KiTagListOptions[]
): DataKiSyokenResponse => {
  if (kiTagList.length === 0) {
    return dataKiSyoken;
  }

  const rows = filterTableRowsBySelectedKiTags(
    dataKiSyoken.data.rows,
    kiTagList
  );

  return {
    ...dataKiSyoken,
    data: {
      ...dataKiSyoken.data,
      rows,
    },
  };
};
